export const list = [
    { id: 3, name: 'پرفروشترین', value: 'best_selling' },
    { id: 4, name: 'جدید ترین', value: 'latest' }
]